import { render } from "./FaqSection.vue?vue&type=template&id=d07e8258&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=d07e8258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07e8258"]])

export default __exports__